{
  "PROFILE_SETTINGS": {
    "LINK": "Postavke profila",
    "TITLE": "Postavke profila",
    "BTN_TEXT": "Ažuriraj profil",
    "DELETE_AVATAR": "Izbriši avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar je uspješno izbrisan",
    "AVATAR_DELETE_FAILED": "Došlo je do greške pri brisanju avatara, pokušajte ponovno",
    "UPDATE_SUCCESS": "Vaš profil je uspješno ažuriran",
    "PASSWORD_UPDATE_SUCCESS": "Vaša lozinka je uspješno promijenjena",
    "AFTER_EMAIL_CHANGED": "Vaš profil je uspješno ažuriran, prijavite se ponovno jer su vaši podaci za prijavu promijenjeni",
    "FORM": {
      "PICTURE": "Profilna slika",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Slika za e-mail potpis",
        "HINT": "Koristi se u e-mail potpisima. {'{{'}email_signature_picture{'}}'} zamjenjuje se URL-om ove slike (a ne oznakom slike) — upotrijebite ga kao izvor slike (atribut src img oznake) u svom potpisu ili potpisu sandučića. Ako nije postavljena, ništa se ne umeće.",
        "DELETE_SUCCESS": "Slika za e-mail potpis uspješno je izbrisana",
        "DELETE_FAILED": "Došlo je do pogreške prilikom brisanja slike za e-mail potpis, pokušajte ponovno"
      },
      "AVATAR": "Profilna slika",
      "ERROR": "Molimo ispravite greške u obrascu",
      "REMOVE_IMAGE": "Izbriši",
      "UPLOAD_IMAGE": "Prenesi sliku",
      "UPDATE_IMAGE": "Ažuriraj sliku",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Vaša e-mail adresa je vaš identitet i koristi se za prijavu."
      },
      "SEND_MESSAGE": {
        "TITLE": "Tipkovni prečac za slanje poruka",
        "NOTE": "Možete odabrati tipkovni prečac (Enter ili Cmd/Ctrl+Enter) prema vašim preferencijama pisanja.",
        "UPDATE_SUCCESS": "Vaše postavke su uspješno ažurirane",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Šaljite poruke pritiskom na tipku Enter umjesto klikom na gumb za slanje."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Šaljite poruke pritiskom na Cmd/Ctrl + Enter umjesto klikom na gumb za slanje."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Sučelje",
        "NOTE": "Prilagodite izgled i dojam svoje kontrolne ploče.",
        "FONT_SIZE": {
          "TITLE": "Veličina fonta",
          "NOTE": "Prilagodite veličinu teksta na cijeloj kontrolnoj ploči prema svojim željama.",
          "UPDATE_SUCCESS": "Vaše postavke fonta su uspješno ažurirane",
          "UPDATE_ERROR": "Došlo je do greške pri ažuriranju postavki fonta, pokušajte ponovno",
          "OPTIONS": {
            "SMALLER": "Manje",
            "SMALL": "Malo",
            "DEFAULT": "Zadano",
            "LARGE": "Veliko",
            "LARGER": "Veće",
            "EXTRA_LARGE": "Vrlo veliko"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Jezik kontrolne ploče",
          "NOTE": "Nadjačaj jezik računa za vlastitu kontrolnu ploču. Ostavite prazno za korištenje zadanog jezika računa.",
          "USE_ACCOUNT_DEFAULT": "Koristi zadani jezik računa",
          "API_SUCCESS": "Jezik vaše kontrolne ploče je uspješno ažuriran",
          "API_ERROR": "Došlo je do greške pri ažuriranju jezika kontrolne ploče, pokušajte ponovno"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Jezik poruka",
          "NOTE": "Odaberite želite li prikazati izvorne poruke ili njihove prijevode",
          "ORIGINAL": "Izvorno",
          "TRANSLATED": "Prevedeno"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Ponašanje lijepljenja",
          "NOTE": "Odaberite kako treba obraditi zalijepljeni sadržaj pri sastavljanju poruka",
          "UPDATE_SUCCESS": "Postavke lijepljenja uspješno ažurirane",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Sačuvaj svo oblikovanje",
              "DESCRIPTION": "Sačuvaj svo oblikovanje uključujući tablice, stilove i ostale HTML elemente pri lijepljenju sadržaja."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Tekst samo s poveznicama",
              "DESCRIPTION": "Pretvori u čisti tekst, ali sačuvaj aktivne poveznice pri lijepljenju sadržaja."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Samo čisti tekst",
              "DESCRIPTION": "Ukloni svo oblikovanje i pretvori u čisti tekst pri lijepljenju sadržaja."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Visina okvira za odgovor",
          "NOTE": "Postavite najmanju visinu okvira za odgovor kao postotak visine zaslona. Odnosi se samo na razgovore putem e-maila.",
          "UPDATE_SUCCESS": "Postavka visine okvira za odgovor uspješno ažurirana",
          "PERCENT_LABEL": "Visina (% visine zaslona)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Zadano",
              "DESCRIPTION": "Okvir za odgovor počinje malen i raste kako tipkate."
            },
            "CUSTOM": {
              "HEADING": "Prilagođeno",
              "DESCRIPTION": "Okvir za odgovor uvijek je barem odabranog postotka visine zaslona."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatska navigacija na sljedeći razgovor",
        "NOTE": "Automatski se prebaci na sljedeći otvoreni razgovor nakon rješavanja trenutnog",
        "UPDATE_SUCCESS": "Postavka automatske navigacije uspješno ažurirana"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format pretpregleda e-maila u popisu razgovora",
        "NOTE": "Odaberite što se prikazuje u popisu razgovora za razgovore iz e-mail sandučića",
        "SUBJECT": "Predmet",
        "SUBJECT_WITH_NOTE": "Predmet i posljednja poruka ako je privatna bilješka",
        "UPDATE_SUCCESS": "Postavka pretpregleda e-maila uspješno ažurirana"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Onemogući tipkovničke prečace",
        "NOTE": "Isključi sve tipkovničke prečace u aplikaciji",
        "UPDATE_SUCCESS": "Postavka tipkovničkih prečaca uspješno ažurirana"
      },
      "FOLDER_ORDER": {
        "TITLE": "Redoslijed mapa",
        "NOTE": "Prilagodite redoslijed kojim se mape (prilagođeni pregledi) pojavljuju u bočnoj traci. Povucite i ispustite za promjenu redoslijeda.",
        "NO_FOLDERS": "Nije pronađena nijedna prilagođena mapa. Kreirajte mape za organizaciju vaših razgovora."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfiguracija bočne trake",
        "NOTE": "Prilagodite koji se odjeljci pojavljuju u bočnoj traci razgovora.",
        "SAVE_BUTTON": "Spremi konfiguraciju",
        "UPDATE_SUCCESS": "Konfiguracija bočne trake uspješno ažurirana",
        "UPDATE_ERROR": "Došlo je do greške pri ažuriranju konfiguracije bočne trake, pokušajte ponovno",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Svi razgovori",
          "ALL_CONVERSATIONS_DESC": "Prikaži stavku 'Svi razgovori' u bočnoj traci",
          "INBOX": "Sandučić",
          "INBOX_DESC": "Prikaži glavni sandučić s nepročitanim obavijestima",
          "CONVERSATION_GROUPS": "Spominjanja i neobrađeni",
          "CONVERSATION_GROUPS_DESC": "Prikaži grupe razgovora 'Spominjanja' i 'Neobrađeni'",
          "FOLDERS": "Mape",
          "FOLDERS_DESC": "Prikaži prilagođene preglede (mape) za organizirane razgovore",
          "TEAMS": "Timovi",
          "TEAMS_DESC": "Prikaži razgovore filtrirane po dodjelama tima",
          "CHANNELS": "Sandučići",
          "CHANNELS_DESC": "Prikaži razgovore filtrirane po sandučiću",
          "LABELS": "Oznake",
          "LABELS_DESC": "Prikaži razgovore filtrirane po oznakama"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Postavke telefona",
        "NOTE": "Unesite pristupne podatke za vaš PBX sustav.",
        "USERNAME": "Korisničko ime",
        "PASSWORD": "Lozinka",
        "SUBMIT": "Spremi",
        "USERNAME_INVALID": "Korisničko ime smije sadržavati samo slova, brojeve i . _ - + — bez razmaka i bez e-mail adrese.",
        "API": {
          "USERNAME_INVALID": "Korisničko ime nije ispravno SIP korisničko ime. Koristite samo slova, brojeve i . _ - + — bez razmaka i bez e-mail adrese.",
          "USERNAME_TAKEN": "Ovo korisničko ime već koristi drugi agent na ovom računu."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Osobni potpis poruke",
        "DESCRIPTION": "Kreirajte jedinstveni potpis poruke koji se pojavljuje na kraju svake e-mail poruke koju pošaljete. Možete uključiti i umetnutu sliku.",
        "NOTE": "Kreirajte jedinstveni potpis poruke koji će se prikazivati na kraju svake poruke koju pošaljete iz bilo kojeg sandučića. Možete uključiti i umetnutu sliku, koja je podržana u live chatu, e-mailu i API sandučićima.",
        "BTN_TEXT": "Spremi potpis poruke",
        "API_ERROR": "Potpis nije moguće spremiti! Pokušajte ponovno",
        "API_SUCCESS": "Potpis je uspješno spremljen",
        "IMAGE_UPLOAD_ERROR": "Nije moguće prenijeti sliku! Pokušajte ponovno",
        "IMAGE_UPLOAD_SUCCESS": "Slika je uspješno dodana. Kliknite na spremi da biste spremili potpis",
        "IMAGE_UPLOAD_SIZE_ERROR": "Veličina slike mora biti manja od {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Potpis poruke",
        "ERROR": "Potpis poruke ne može biti prazan",
        "PLACEHOLDER": "Ovdje unesite svoj osobni potpis poruke."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Lozinka",
        "NOTE": "Ažuriranje lozinke poništit će vaše prijave na više uređaja.",
        "BTN_TEXT": "Promijeni lozinku"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Pristupni token",
        "NOTE": "Ovaj token se može koristiti ako izrađujete integraciju temeljenu na API-ju",
        "COPY": "Kopiraj",
        "REGENERATE": "Regeneriraj",
        "REGENERATE_SUCCESS": "Pristupni token uspješno regeneriran. Ažurirajte sve integracije koje koriste stari token.",
        "REGENERATE_CONFIRM_TITLE": "Regenerirati pristupni token?",
        "REGENERATE_CONFIRM_MESSAGE": "Ovo će poništiti trenutni token. Sve integracije koje koriste stari token prestat će raditi."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome ekstenzija",
        "NOTE": "Instalirajte našu Chrome ekstenziju za bogate obavijesti o dolaznim telefonskim pozivima.",
        "INSTALL_BUTTON": "Instaliraj ekstenziju",
        "ALREADY_INSTALLED": "Ekstenzija instalirana"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Zvučna upozorenja",
        "NOTE": "Omogućite zvučna upozorenja na kontrolnoj ploči za nove poruke i razgovore.",
        "PLAY": "Reproduciraj zvuk",
        "ALERT_TYPES": {
          "NONE": "Nijedno",
          "MINE": "Dodijeljeno",
          "ALL": "Sve",
          "ASSIGNED": "Moji dodijeljeni razgovori",
          "UNASSIGNED": "Nedodijeljeni razgovori",
          "NOTME": "Otvoreni razgovori dodijeljeni drugima"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Niste odabrali nijednu opciju, nećete primati nikakva zvučna upozorenja.",
          "ASSIGNED": "Primat ćete upozorenja za razgovore dodijeljene vama.",
          "UNASSIGNED": "Primat ćete upozorenja za sve nedodijeljene razgovore.",
          "NOTME": "Primat ćete upozorenja za razgovore dodijeljene drugima.",
          "ASSIGNED+UNASSIGNED": "Primat ćete upozorenja za svoje dodijeljene razgovore i sve neobrađene razgovore.",
          "ASSIGNED+NOTME": "Primat ćete upozorenja za razgovore dodijeljene vama i drugima, ali ne i za nedodijeljene.",
          "NOTME+UNASSIGNED": "Primat ćete upozorenja za neobrađene razgovore i one dodijeljene drugima.",
          "ASSIGNED+NOTME+UNASSIGNED": "Primat ćete upozorenja za sve razgovore."
        },
        "ALERT_TYPE": {
          "TITLE": "Vrste upozorenja za razgovore",
          "NONE": "Nijedno",
          "ASSIGNED": "Dodijeljeni razgovori",
          "ALL_CONVERSATIONS": "Svi razgovori"
        },
        "DEFAULT_TONE": {
          "TITLE": "Ton obavijesti:"
        },
        "CONDITIONS": {
          "TITLE": "Uvjeti upozorenja:",
          "CONDITION_ONE": "Pošalji zvučna upozorenja samo ako prozor preglednika nije aktivan",
          "CONDITION_TWO": "Šalji upozorenja svakih 10 sekundi dok svi dodijeljeni razgovori ne budu pročitani"
        },
        "SOUND_PERMISSION_ERROR": "Automatska reprodukcija je onemogućena u vašem pregledniku. Da biste automatski čuli upozorenja, omogućite dozvolu za zvuk u postavkama preglednika ili interagirajte sa stranicom.",
        "READ_MORE": "Pročitaj više"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-mail obavijesti",
        "NOTE": "Ovdje ažurirajte postavke svojih e-mail obavijesti",
        "CONVERSATION_ASSIGNMENT": "Šalji e-mail obavijesti kada mi je razgovor dodijeljen",
        "CONVERSATION_CREATION": "Šalji e-mail obavijesti kada se kreira novi razgovor",
        "CONVERSATION_MENTION": "Šalji e-mail obavijesti kada ste spomenuti u razgovoru",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Šalji e-mail obavijesti kada se kreira nova poruka u dodijeljenom razgovoru",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Šalji e-mail obavijesti kada se kreira nova poruka u razgovoru u kojem sudjelujete",
        "SLA_MISSED_FIRST_RESPONSE": "Šalji e-mail obavijesti kada razgovor propusti SLA za prvi odgovor",
        "SLA_MISSED_NEXT_RESPONSE": "Šalji e-mail obavijesti kada razgovor propusti SLA za sljedeći odgovor",
        "SLA_MISSED_RESOLUTION": "Šalji e-mail obavijesti kada razgovor propusti SLA za rješavanje"
      },
      "NOTIFICATIONS": {
        "TITLE": "Postavke obavijesti",
        "TYPE_TITLE": "Vrsta obavijesti",
        "EMAIL": "E-mail",
        "PUSH": "Push obavijest",
        "TYPES": {
          "CONVERSATION_CREATED": "Kreira se novi razgovor",
          "CONVERSATION_ASSIGNED": "Razgovor vam je dodijeljen",
          "CONVERSATION_MENTION": "Spomenuti ste u razgovoru",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova poruka je kreirana u dodijeljenom razgovoru",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nova poruka je kreirana u razgovoru u kojem sudjelujete",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Kreirana je nova poruka u razgovoru bez dostupnog agenta",
          "SLA_MISSED_FIRST_RESPONSE": "Razgovor propušta SLA za prvi odgovor",
          "SLA_MISSED_NEXT_RESPONSE": "Razgovor propušta SLA za sljedeći odgovor",
          "SLA_MISSED_RESOLUTION": "Razgovor propušta SLA za rješavanje"
        },
        "BROWSER_PERMISSION": "Omogućite push obavijesti za svoj preglednik kako biste ih mogli primati",
        "ALLOW_NOTIFICATION_DURING_CALL": "Dopusti push obavijesti tijekom poziva",
        "TEST_PUSH": "Testiraj",
        "TESTING": "Testiranje...",
        "TEST_PUSH_DESCRIPTION": "Pošaljite testne obavijesti za provjeru postavki",
        "TEST_NOTIFICATION_ERROR": "Slanje testne obavijesti nije uspjelo. Pokušajte ponovno.",
        "TEST_LOCAL_TITLE": "Testna obavijest (lokalno)",
        "TEST_LOCAL_BODY": "Ovo je lokalna obavijest preglednika. Ako vidite ovo, obavijesti preglednika rade!"
      },
      "API": {
        "UPDATE_SUCCESS": "Vaše postavke obavijesti uspješno su ažurirane",
        "UPDATE_ERROR": "Došlo je do greške pri ažuriranju postavki, pokušajte ponovno"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push obavijesti",
        "NOTE": "Ovdje ažurirajte postavke svojih push obavijesti",
        "CONVERSATION_ASSIGNMENT": "Šalji push obavijesti kada mi je razgovor dodijeljen",
        "CONVERSATION_CREATION": "Šalji push obavijesti kada se kreira novi razgovor",
        "CONVERSATION_MENTION": "Šalji push obavijesti kada ste spomenuti u razgovoru",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Šalji push obavijesti kada se kreira nova poruka u dodijeljenom razgovoru",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Šalji push obavijesti kada se kreira nova poruka u razgovoru u kojem sudjelujete",
        "HAS_ENABLED_PUSH": "Omogućili ste push obavijesti za ovaj preglednik.",
        "REQUEST_PUSH": "Omogući push obavijesti",
        "SLA_MISSED_FIRST_RESPONSE": "Šalji push obavijesti kada razgovor propusti SLA za prvi odgovor",
        "SLA_MISSED_NEXT_RESPONSE": "Šalji push obavijesti kada razgovor propusti SLA za sljedeći odgovor",
        "SLA_MISSED_RESOLUTION": "Šalji push obavijesti kada razgovor propusti SLA za rješavanje"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilna slika"
      },
      "NAME": {
        "LABEL": "Vaše puno ime",
        "ERROR": "Unesite ispravno puno ime",
        "PLACEHOLDER": "Unesite svoje puno ime"
      },
      "DISPLAY_NAME": {
        "LABEL": "Prikazano ime",
        "ERROR": "Unesite ispravno prikazano ime",
        "PLACEHOLDER": "Unesite prikazano ime, ono će se prikazivati u razgovorima"
      },
      "POSITION": {
        "LABEL": "Pozicija",
        "ERROR": "Unesite ispravnu poziciju",
        "PLACEHOLDER": "Unesite svoju poziciju"
      },
      "CUSTOM_LINE": {
        "LABEL": "Prilagođeni redak",
        "ERROR": "Unesite ispravan prilagođeni redak",
        "PLACEHOLDER": "Unesite svoj prilagođeni redak"
      },
      "AVAILABILITY": {
        "LABEL": "Dostupnost",
        "STATUS": {
          "ONLINE": "Dostupan",
          "BUSY": "Zauzet",
          "OFFLINE": "Nedostupan"
        },
        "SET_AVAILABILITY_SUCCESS": "Dostupnost je uspješno postavljena",
        "SET_AVAILABILITY_ERROR": "Nije moguće postaviti dostupnost, pokušajte ponovno"
      },
      "EMAIL": {
        "LABEL": "Vaša e-mail adresa",
        "ERROR": "Unesite ispravnu e-mail adresu",
        "PLACEHOLDER": "Unesite svoju e-mail adresu, ona će se prikazivati u razgovorima"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Trenutna lozinka",
        "ERROR": "Unesite trenutnu lozinku",
        "PLACEHOLDER": "Unesite trenutnu lozinku"
      },
      "PASSWORD": {
        "LABEL": "Nova lozinka",
        "ERROR": "Unesite lozinku duljine 6 ili više znakova",
        "PLACEHOLDER": "Unesite novu lozinku"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Potvrdite novu lozinku",
        "ERROR": "Potvrdna lozinka mora odgovarati lozinci",
        "PLACEHOLDER": "Ponovno unesite novu lozinku"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Promijeni",
    "CHANGE_ACCOUNTS": "Promijeni račun",
    "SWITCH_ACCOUNT": "Promijeni račun",
    "CONTACT_SUPPORT": "Kontaktiraj podršku",
    "REPORT_BUG": "Prijavi grešku",
    "SELECTOR_SUBTITLE": "Odaberite račun s popisa u nastavku",
    "PROFILE_SETTINGS": "Postavke profila",
    "KEYBOARD_SHORTCUTS": "Tipkovnički prečaci",
    "APPEARANCE": "Promijeni izgled",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin konzola",
    "DOCS": "Pročitaj dokumentaciju",
    "LOGOUT": "Odjava"
  },
  "BUG_REPORT": {
    "TITLE": "Prijavi grešku",
    "DESCRIPTION_LABEL": "Opis problema",
    "DESCRIPTION_PLACEHOLDER": "Opišite problem na koji ste naišli...",
    "SUBMIT": "Pošalji prijavu",
    "SUBMITTING": "Slanje...",
    "CANCEL": "Odustani",
    "SUCCESS": "Prijava greške uspješno poslana. Hvala!",
    "ERROR": "Slanje prijave greške nije uspjelo. Pokušajte ponovno.",
    "VALIDATION_ERROR": "Opišite problem prije slanja"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dana preostalo u probnom razdoblju.",
    "TRAIL_BUTTON": "Kupi sada",
    "DELETED_USER": "Izbrisani korisnik",
    "EMAIL_VERIFICATION_PENDING": "Čini se da još niste potvrdili svoju e-mail adresu. Provjerite svoju pristiglu poštu za e-mail potvrde.",
    "RESEND_VERIFICATION_MAIL": "Ponovno pošalji e-mail za potvrdu",
    "EMAIL_VERIFICATION_SENT": "E-mail za potvrdu je poslan. Provjerite svoju pristiglu poštu.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Račun suspendiran",
      "MESSAGE": "Vaš račun je suspendiran. Obratite se timu za podršku za više informacija."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopiraj",
      "CODEPEN": "Otvori u CodePenu",
      "COPY_SUCCESSFUL": "Kopirano u međuspremnik"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Prikaži više",
      "SHOW_LESS": "Prikaži manje"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Preuzmi",
      "UPLOADING": "Prenosim...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ova priča više nije dostupna.",
      "RECORDING_UNAVAILABLE": "Ova snimka više nije dostupna.",
      "DELETE_RECORDING": {
        "BUTTON": "Izbriši snimku poziva",
        "TITLE": "Izbrisati snimku poziva?",
        "DESCRIPTION": "Sve snimke ovog poziva trajno će se izbrisati iz telefonskog sustava i ne mogu se vratiti. Transkript i sažetak poziva ostaju.",
        "CONFIRM": "Izbriši",
        "SUCCESS": "Snimka poziva je izbrisana",
        "ERROR": "Snimku poziva nije bilo moguće izbrisati. Pokušajte ponovno."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Pogledaj na karti"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Pošalji"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Ova slika više nije dostupna.",
      "LOADING_FAILED": "Učitavanje nije uspjelo"
    }
  },
  "CONFIRM_EMAIL": "Potvrđivanje...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Dodaj sandučić"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Nema stavki",
    "CURRENTLY_VIEWING_ACCOUNT": "Trenutno pregledavate:",
    "SWITCH": "Promijeni",
    "INBOX_VIEW": "Prikaz sandučića",
    "CONVERSATIONS": "Razgovori",
    "INBOX": "Moj sandučić",
    "ALL_CONVERSATIONS": "Svi razgovori",
    "MENTIONED_CONVERSATIONS": "Spominjanja",
    "PARTICIPATING_CONVERSATIONS": "Sudjelujem",
    "UNATTENDED_CONVERSATIONS": "Neobrađeni",
    "REPORTS": "Izvještaji",
    "SETTINGS": "Postavke",
    "CONTACTS": "Kontakti",
    "DATA_ASSISTANT": "Podatkovni asistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Asistenti",
    "CAPTAIN_DOCUMENTS": "Dokumenti",
    "CAPTAIN_RESPONSES": "Česta pitanja",
    "HOME": "Početna",
    "AGENTS": "Agenti",
    "AGENT_BOTS": "Botovi",
    "AUDIT_LOGS": "Audit logovi",
    "WHATSAPP_TEMPLATES": "WhatsApp predlošci",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Sandučići",
    "NOTIFICATIONS": "Obavijesti",
    "CANNED_RESPONSES": "Spremljeni odgovori",
    "INTEGRATIONS": "Integracije",
    "PROFILE_SETTINGS": "Postavke profila",
    "ACCOUNT_SETTINGS": "Postavke računa",
    "APPLICATIONS": "Aplikacije",
    "LABELS": "Oznake",
    "CUSTOM_ATTRIBUTES": "Prilagođeni atributi",
    "AUTOMATION": "Automatizacija",
    "MACROS": "Makronaredbe",
    "TEAMS": "Timovi",
    "BILLING": "Naplata",
    "CUSTOM_VIEWS_FOLDER": "Mape",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenti",
    "ALL_CONTACTS": "Svi kontakti",
    "TAGGED_WITH": "Označeno s",
    "NEW_LABEL": "Nova oznaka",
    "NEW_TEAM": "Novi tim",
    "NEW_INBOX": "Novi sandučić",
    "REPORTS_CONVERSATION": "Razgovori",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Razgovor uživo",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampanje",
    "ONGOING": "U tijeku",
    "ONE_OFF": "Jednokratno",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenti",
    "REPORTS_LABEL": "Oznake",
    "REPORTS_INBOX": "Sandučić",
    "REPORTS_TEAM": "Tim",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Pregled",
    "WALLBOARD_QUEUES": "Redovi čekanja",
    "WALLBOARD_AGENTS": "Pregled agenata",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Izvještaji",
    "NO_WAITING_CALLERS": "nema pozivatelja na čekanju",
    "WAITING_CALLERS": "{count} pozivatelja na čekanju",
    "SET_AVAILABILITY_TITLE": "Postavi sebe kao",
    "SET_YOUR_AVAILABILITY": "Postavi svoju dostupnost",
    "AVAILABILITY_IMPERSONATING": "Zaključano dok ste prijavljeni kao ovaj korisnik",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Prilagođene uloge",
    "NEW_CONVERSATION": "Novi razgovor",
    "DRAFT": "Skica",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Pregled",
    "REAUTHORIZE": "Veza vašeg sandučića je istekla, ponovno se povežite\n kako biste nastavili primati i slati poruke",
    "HELP_CENTER": {
      "TITLE": "Centar za pomoć",
      "ARTICLES": "Članci",
      "CATEGORIES": "Kategorije",
      "LOCALES": "Jezici",
      "SETTINGS": "Postavke",
      "DICTIONARY": "Rječnik"
    },
    "CHANNELS": "Kanali",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Označi kao offline automatski",
      "INFO_TEXT": "Neka vas sustav automatski označi kao offline kada ne koristite aplikaciju ili kontrolnu ploču.",
      "INFO_SHORT": "Automatski označi kao offline kada ne koristite aplikaciju."
    },
    "DOCS": "Pročitaj članke"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokirane domene i kontakti",
    "DESCRIPTION": "Popis blokiranih e-mail domena za ovaj račun.",
    "NO_BLOCKED_DOMAINS": "Nije pronađena nijedna blokirana domena.",
    "BLOCKED_CONTACTS_BTN": "Blokirani kontakti"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Naplata",
    "DESCRIPTION": "Ovdje upravljajte svojom pretplatom, nadogradite plan i dobite više za svoj tim.",
    "CURRENT_PLAN": {
      "TITLE": "Trenutni plan",
      "PLAN_NOTE": "Trenutno ste pretplaćeni na plan **{plan}** s **{quantity}** licenci",
      "SEAT_COUNT": "Broj mjesta",
      "RENEWS_ON": "Obnavlja se"
    },
    "VIEW_PRICING": "Pogledaj cijene",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Upravljanje pretplatom",
      "DESCRIPTION": "Pregledajte prethodne račune, uredite podatke za naplatu ili otkažite pretplatu.",
      "BUTTON_TXT": "Idi na portal za naplatu"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Upravljajte korištenjem i kreditima za Captain AI.",
      "BUTTON_TXT": "Kupi više kredita",
      "DOCUMENTS": "Dokumenti",
      "RESPONSES": "Odgovori",
      "UPGRADE": "Captain nije dostupan u besplatnom planu, nadogradite sada kako biste dobili pristup asistentima, copilot-u i još mnogo toga."
    },
    "CHAT_WITH_US": {
      "TITLE": "Trebate pomoć?",
      "DESCRIPTION": "Imate li problema s naplatom? Tu smo da pomognemo.",
      "BUTTON_TXT": "Čavrljajte s nama"
    },
    "NO_BILLING_USER": "Vaš račun za naplatu se konfigurira. Osvježite stranicu i pokušajte ponovno."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh oh! Nismo mogli pronaći nijedan račun. Kreirajte novi račun za nastavak.",
    "NEW_ACCOUNT": "Novi račun",
    "SELECTOR_SUBTITLE": "Kreirajte novi račun",
    "API": {
      "SUCCESS_MESSAGE": "Račun uspješno kreiran",
      "EXIST_MESSAGE": "Račun već postoji",
      "ERROR_MESSAGE": "Nije moguće povezati se s chat serverom. Pokušajte ponovno kasnije"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Naziv tvrtke",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Pošalji",
      "CANCEL": "Odustani"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Vidi sve skraćenice",
    "TITLE": {
      "OPEN_CONVERSATION": "Otvori razgovor",
      "RESOLVE_AND_NEXT": "Riješi i prijeđi na sljedeći",
      "NAVIGATE_DROPDOWN": "Kreći se kroz stavke padajućeg izbornika",
      "RESOLVE_CONVERSATION": "Riješi razgovor",
      "GO_TO_CONVERSATION_DASHBOARD": "Idi na kontrolnu ploču razgovora",
      "ADD_ATTACHMENT": "Dodaj privitak",
      "GO_TO_CONTACTS_DASHBOARD": "Idi na kontrolnu ploču kontakata",
      "TOGGLE_SIDEBAR": "Uključi/isključi bočnu traku",
      "GO_TO_REPORTS_SIDEBAR": "Idi na bočnu traku izvještaja",
      "MOVE_TO_NEXT_TAB": "Prijeđi na sljedeću karticu u popisu razgovora",
      "GO_TO_SETTINGS": "Idi na postavke",
      "SWITCH_TO_PRIVATE_NOTE": "Prebaci na privatnu bilješku",
      "SWITCH_TO_REPLY": "Prebaci na odgovor",
      "TOGGLE_SNOOZE_DROPDOWN": "Uključi/isključi padajući izbornik odgode",
      "AI_ASSIST_MENU": "AI pomoć",
      "AI_ASSIST_GRAMMAR": "Ispravi gramatiku",
      "AI_ASSIST_UNIFY_LANG": "Ujednači jezik poruke"
    }
  }
}
